<template>
  <section>
    <log-write-modal :key="reload" :today="today" :is-open="isOpenWriteModal" @close="closeModal" />
    <div class="inner">
      <h2 class="Head Head--cl01 Head--mg_md">
        <span class="Head__main Head--md">Mindful log</span><br><span
          class="Head__main_jp"
        >マインドフルログ</span>
      </h2>
      <div class="Log__area">
        <div class="Log__side">
          <div class="Log__record_btn" @click="writeLog()">
            <span>ログを記録</span>
          </div>
        </div>
        <log-chart :key="reload" />
      </div>
    </div>
  </section>
</template>

<script>
import LogChart from '@/views/components/Log/LogChart'
import LogWriteModal from '@/views/pages/log/components/LogWriteModal'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'MindfulLog',
  components: { LogChart, LogWriteModal },
  data() {
    return {
      isOpenWriteModal: false,
      reload: 0,
      today: ''
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin
    })
  },
  created() {
    this.getToday()
  },
  methods: {
    closeModal(type) {
      this.isOpenWriteModal = false
      if (type === 'updated') {
        this.reload++
      }
    },
    getToday() {
      const now = new Date()
      this.today = moment(now).format('Y-M-D')
    },
    writeLog() {
      if (this.isLogin) {
        this.isOpenWriteModal = true
      } else {
        window.location.href = '/signin'
      }
    }
  }

}
</script>
